import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { adminFetch } from '@/lib/api';

type Overview = {
  paying_clients: number;
  past_due: number;
  trials_expiring_7d: number;
  new_clients_7d: number;
  revenue_last_30d_cents: number;
  mrr_estimate_cents: number;
};

function brl(cents: number) {
  return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function OverviewPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['billing-overview'],
    queryFn: () => adminFetch<Overview>('/billing/overview'),
  });

  if (isLoading) return <p className="text-neutral-400">Carregando…</p>;
  if (error) return <p className="text-red-400">{error instanceof Error ? error.message : 'Erro'}</p>;

  const cards = [
    { label: 'Clientes pagando', value: String(data?.paying_clients ?? 0) },
    { label: 'Past due', value: String(data?.past_due ?? 0), warn: (data?.past_due ?? 0) > 0 },
    { label: 'Trials a vencer (7d)', value: String(data?.trials_expiring_7d ?? 0) },
    { label: 'Novos clientes (7d)', value: String(data?.new_clients_7d ?? 0) },
    { label: 'Receita 30 dias', value: brl(data?.revenue_last_30d_cents ?? 0) },
    { label: 'MRR estimado', value: brl(data?.mrr_estimate_cents ?? 0) },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold">Visão geral</h1>
        <p className="text-sm text-neutral-400">Saúde de assinaturas e aquisição</p>
      </div>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((c) => (
          <div
            key={c.label}
            className={`rounded-xl border border-neutral-800 bg-neutral-900/50 p-4 ${
              c.warn ? 'border-amber-700/60' : ''
            }`}
          >
            <p className="text-xs text-neutral-400">{c.label}</p>
            <p className="mt-1 text-2xl font-semibold">{c.value}</p>
          </div>
        ))}
      </div>

      <div className="flex flex-wrap gap-3 text-sm">
        <Link to="/billing?past_due=1" className="rounded-lg border border-neutral-700 px-3 py-2 hover:bg-neutral-900">
          Ver falhas de cobrança
        </Link>
        <Link to="/billing?trials=1" className="rounded-lg border border-neutral-700 px-3 py-2 hover:bg-neutral-900">
          Trials expirando
        </Link>
        <Link to="/clients" className="rounded-lg border border-neutral-700 px-3 py-2 hover:bg-neutral-900">
          Clientes / módulos
        </Link>
        <Link to="/media" className="rounded-lg border border-neutral-700 px-3 py-2 hover:bg-neutral-900">
          Curadoria ML
        </Link>
        <Link to="/pipeline" className="rounded-lg border border-neutral-700 px-3 py-2 hover:bg-neutral-900">
          Pipeline ML
        </Link>
      </div>
    </div>
  );
}
